import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import storage from 'local-storage-fallback';
import jwt from 'jsonwebtoken';
import qs from 'query-string';
import Login from './screens/Login';
import { login } from './api/login';
import {
  ROLES, BOOKING_PATH, CMS_PATH, REPORT_PATH, MARKETING_PATH, USERS_PATH, AGENCY_PATH,
} from './utils/constants';
import Routes from './routes';
import AuthController from './routes/AuthContainer';
import Navbar from './components/Navbar';
import Search from './components/Search';
import Link from './components/WrappedLink';

import 'material-icons/iconfont/material-icons.css';
import 'material-icons/css/material-icons.css';
import 'bulma/css/bulma.min.css';
import 'react-toastify/dist/ReactToastify.min.css';
import './App.css';
import LeftMenu from './routes/Menu';
import Selection from './screens/Selection';
import { hasRole } from './utils/general';
import { saveToken, saveUser } from './utils/persist';

const App = () => {
  const [userJSON, setUser] = useState(() => storage.getItem('user'));
  const user = JSON.parse(userJSON);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!user || !user.roles || user.roles.length === 0) {
      return;
    }

    const { redirectTo } = qs.parse(window.location.search);
    if (redirectTo) {
      window.location.href = redirectTo;
      return;
    }

    // REDIRECT OTHER SECTIONS (CMS and BOOKING)
    // allowed sections
    // if there is only one allowed section redirect to it
    let allowedSections = 0;
    let redirectPath;

    if (hasRole(ROLES.CMS)) {
      allowedSections++;
      redirectPath = CMS_PATH;
    }

    if (hasRole(ROLES.BOOKING)) {
      allowedSections++;
      redirectPath = BOOKING_PATH;
    }

    if (hasRole(ROLES.REPORT)) {
      allowedSections++;
      redirectPath = REPORT_PATH;
    }

    if (hasRole(ROLES.MARKETING)) {
      allowedSections++;
      redirectPath = MARKETING_PATH;
    }

    if (hasRole(ROLES.USER_MANAGER)) {
      allowedSections++;
      redirectPath = USERS_PATH;
    }

    if (hasRole(ROLES.AGENCY)) {
      allowedSections++;
      redirectPath = AGENCY_PATH;
    }

    if (allowedSections === 1) {
      window.location.href = `/${redirectPath}`;
    }
  });

  const handleLogin = async (username, password) => {
    setLoading(true);

    try {
      const { token } = await login(username, password);
      const user = {
        ...jwt.decode(token),
        token,
      };

      saveUser(user);
      saveToken(token, user.exp);
      setUser(JSON.stringify(user));

      setLoading(false);
    } catch (e) {
      setError(e?.response?.data.message || 'Errore. Riprovare il login.');
      setLoading(false);
    }
  };

  // check if it's root or login path url
  const isLoginOrRootUrl = () => {
    return (
      window.location.pathname === ''
      || window.location.pathname === '/'
      || window.location.pathname === '/login/'
      || window.location.pathname === '/login'
    );
  };

  // if the user has multiple roles then show selection page or is there marketing
  if (isLoginOrRootUrl() && user?.roles?.length > 1) {
    return <Selection roles={user.roles} />;
  }

  // show main application
  if (user?.roles?.length > 0) {
    return (
      <Router>
        <ToastContainer />
        <AuthController>
          <div>
            <Navbar>
              <Search />
              <Link className="navbar-item" to="/users/notifications">
                <i className="mi mi-notifications" />
              </Link>
            </Navbar>
            <div className="container is-fluid is-marginless main-container p-0" style={{ zIndex: 0 }}>
              <div className="columns is-6 is-variable is-marginless" style={{ minHeight: '100vh' }}>
                <div className="column is-2" style={{ paddingTop: '2rem', backgroundColor: '#4e5d6c' }}>
                  <LeftMenu />
                </div>
                <div className="column is-10 pt-5  light-grey" style={{ paddingTop: '2rem', paddingBottom: '2rem' }}>
                  <Routes roles={user.roles} />
                </div>
              </div>
            </div>
          </div>
        </AuthController>
      </Router>
    );
  }

  return <Login handleLogin={handleLogin} loading={loading} error={error} />;
};

export default App;
